<template>
  <span>
    <v-container fluid>
      <v-row>
        <v-col md='3' class="pa-0 mt-6 ml-6">
          <v-card class="pa-2 history-card">
            <span v-show="articleDeleted" class="deletion-note">
              Deletion Note: {{ deletionNote }}
            </span>
            <v-text-field class="mb-0 pb-0" label="Search everything" v-model="filterText"/>
            <v-simple-table class="ma-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Type
                    </th>
                    <th class="text-left">
                      Time
                    </th>
                    <th class="text-left">
                      User
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :class="{selected: selectedIndex === i, 'history-snapshot': selectedIndex !== i}"
                    v-for="(snapshot, i) in articleHistoryFiltered"
                    :key="i"
                    @click="select(i)"
                  >
                    <td class="history-type-text">{{ snapshot.lastAction.type }}</td>
                    <td class="history-date-text">{{ new Date(snapshot.lastAction.date).toLocaleString('en-US', dateOptions) }}</td>
                    <td class="history-user-text">{{ snapshot.lastAction.user }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
        <v-col>
          <Article/>
        </v-col>
      </v-row>
    </v-container>
  </span>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Article from '@/components/Article'
export default {
  name: 'ArticleHistory',
  components: {
    Article
  },
  data: () => ({
    selectedIndex: 0,
    filterText: '',
    dateOptions: { year: '2-digit', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timezone: Intl.DateTimeFormat().resolvedOptions().timeZone }
  }),
  mounted () {
    this.select(0)
  },
  methods: {
    ...mapMutations('article', ['setCurrentArticle', 'setArticleValid']),
    select (i) {
      this.setCurrentArticle(this.articleHistoryFiltered[i])
      this.selectedIndex = i
      this.setArticleValid(i !== 0 || this.filterText !== '' || this.articleDeleted) // deleted article can be restored to deleted state
    }
  },
  watch: {
    filterText () {
      this.select(0)
    }
  },
  computed: {
    ...mapState('article', {
      articleHistory: state => state.articleHistory,
      deletionNote: state => state.deletionNote,
      articleDeleted: state => state.articleDeleted
    }),
    articleHistoryFiltered () {
      // filter all fields
      return this.articleHistory.filter(e => {
        const timestring = new Date(e.lastAction.date).toLocaleString('en-US', this.dateOptions)
        if (timestring.toLowerCase().includes(this.filterText.toLowerCase())) {
          return true
        }
        return Object.values(e).reduce((sum, val) => {
          if (typeof (val) === 'object') {
            return sum || Object.values(val).reduce((childSum, childVal) => {
              if (typeof (childVal) === 'string') {
                return childVal.toLowerCase().includes(this.filterText.toLowerCase()) || childSum
              }
              return childSum
            }, false)
          }
          if (typeof (val) === 'string') {
            return val.toLowerCase().includes(this.filterText.toLowerCase()) || sum
          }
          return sum
        }, false)
      }).sort((a, b) => (new Date(b.lastAction.date).getTime() - (new Date(a.lastAction.date)).getTime()))
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$store
      .dispatch('article/transactions/getArticleHistoryAction', to.params.pathMatch)
      .then(() => next())
  }
}
</script>

<style>
.deletion-note {
  font-weight: bold;
}
.history-card {
  overflow-y: auto;
  max-height: calc(100vh - 180px);
}
.history-snapshot {
  cursor: pointer;
}
.history-snapshot:hover {
  background-color: rgba(0, 47, 255, 0.24);
}
.selected {
  font-weight: bold;
}
.history-type-text {
  color: grey;
}
.history-date-text {
  color: black;
}
.history-user-text {
  color: rgb(67, 67, 255);
}
</style>
